import React, {useEffect} from "react";
import LicencePageContainer from "./Licence.style";
import LicenceDatatable from "./components/LicenceDatatable/LicenceDatatable";
import useController from "./Licence.controller";
import {Button, Card} from "antd";
import PlusOutlined from "@ant-design/icons/es/icons/PlusOutlined";
import {useThemeSelector} from "../../redux/reducers/themeReducer";
import LicenceList from "./components/LicenceList/LicenceList";
import {withRouter} from "react-router-dom";
import LicenceDetailsDrawer from "./components/LicenceDetailsDrawer/LicenceDetailsDrawer";

const Licence = ({history}) => {
    const {primaryColor, darkMode} = useThemeSelector();
    const {
        licences, loading, getLicences, setAddLicenceClicked, onLicenceSend, onSendPassword, onRevokeClick, onDeleteClick,
        onSendOfflineValidationTokenViaSms, onSendOfflineValidationTokenViaEmail,
        onPublicKeyDownload, showLicenceInfo, onLicenceDownload, companyOptions, softwareProductOptions, isDeviceSmall, isDeviceMedium,
        licenceDetailsVisible, licenceToShowDetailsFor, toggleLicenceDetails
    } = useController({history});

    useEffect(() => {
        getLicences();
    }, []);

    return <LicencePageContainer>

        <Card title='Licences'>

            <Button key="3" type="primary" onClick={setAddLicenceClicked}>
                <PlusOutlined/>
                Add
            </Button>

            {isDeviceMedium ? <LicenceList onLicenceSend={onLicenceSend}
                                           onPublicKeyDownload={onPublicKeyDownload}
                                           showLicenceInfo={showLicenceInfo}
                                           onLicenceDownload={onLicenceDownload}
                                           onSendPassword={onSendPassword} onRevokeClick={onRevokeClick}
                                           onDeleteClick={onDeleteClick}
                                           toggleLicenceDetails={toggleLicenceDetails}
                                           licenceDetailsVisible={licenceDetailsVisible}
                                           licenceToShowDetailsFor={licenceToShowDetailsFor}
                                           data={licences} loading={loading} primaryColor={primaryColor}/> :
                <LicenceDatatable companyOptions={companyOptions}
                                  softwareProductOptions={softwareProductOptions} onLicenceSend={onLicenceSend}
                                  showLicenceInfo={showLicenceInfo}
                                  onPublicKeyDownload={onPublicKeyDownload} onLicenceDownload={onLicenceDownload}
                                  onSendPassword={onSendPassword} onRevokeClick={onRevokeClick}
                                  onDeleteClick={onDeleteClick}
                                  toggleLicenceDetails={toggleLicenceDetails}
                                  licenceDetailsVisible={licenceDetailsVisible}
                                  licenceToShowDetailsFor={licenceToShowDetailsFor}
                                  data={licences} loading={loading} primaryColor={primaryColor} darkMode={darkMode}/>
            }
        </Card>

        <LicenceDetailsDrawer darkMode={darkMode} licenceToShowDetailsFor={licenceToShowDetailsFor} primaryColor={primaryColor}
                              licenceDetailsVisible={licenceDetailsVisible}
                              toggleLicenceDetails={toggleLicenceDetails}
                              onRevokeClick={onRevokeClick}
                              onDeleteClick={onDeleteClick}
                              onLicenceSend={onLicenceSend}
                              onSendPassword={onSendPassword}
                              onSendOfflineValidationTokenViaSms={onSendOfflineValidationTokenViaSms}
                              onSendOfflineValidationTokenViaEmail={onSendOfflineValidationTokenViaEmail}
                              showLicenceInfo={showLicenceInfo}
                              onLicenceDownload={onLicenceDownload}
                              onPublicKeyDownload={onPublicKeyDownload}
        />

    </LicencePageContainer>
};

export default withRouter(Licence);